import { ServiceFetch } from '../service-fetch'

export default class JournalListModel extends ServiceFetch {
    getJournalListBy = (data) => this.authFetch({
        url: 'journal-list/getJournalListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}